import React from 'react';
import { isSalesConversationFlow } from '../../../../../../common/src/utils/globalVariables';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import AddressInputComponent from './AddressInputComponent';
import DriverAddressInputComponent from './DriverAddressInputComponent';
import SimpleAddressInputComponent from './SimpleAddressInputComponent';
import useIsInsideModal from '../../company-scan-inputs/table/context/useIsInsideModal';
interface Props {
  question: FlowsQuestion;
}

const AddressInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  ...props
}) => {
  const isInsideModal = useIsInsideModal();
  const simpleAddressInputGroups = ['DRIVER', 'CAR'];

  // Use simple address component when inside table modal to avoid full screen rendering
  if (isInsideModal) {
    return <SimpleAddressInputComponent question={question} />;
  }

  if (
    simpleAddressInputGroups.includes(question.tag || '') &&
    isSalesConversationFlow()
  ) {
    return <DriverAddressInputComponent question={question} />;
  }
  return <AddressInputComponent question={question} {...props} />;
};

export default AddressInputPicker;
